<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Manage Roles') }}</h1>
                        <create-role :dialogFormVisible="dialogFormVisible" @popupsave="getRole" @popup="value => { this.dialogFormVisible = value }" @parentRoles="value => { this.parent_roles = value }" />
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <el-table :data="roles.data" @sort-change="handleSortChange" fit highlight-current-row>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="60" fixed></el-table-column>
                                    <el-table-column :label="$t('Actions')" colspan="2" width="130">
                                        <template slot-scope="scope">
                                            <ul class="act-list">
                                                <li v-if="scope.row.edit">
                                                    <a href="javascript:void(0);" @click="confirmEdit(scope.row)"><i class="el-icon-check"></i></a>
                                                </li>
                                                <li v-if="scope.row.edit">
                                                    <a href="javascript:void(0);" @click="cancelEdit(scope.row)"><i class="el-icon-close"></i></a>
                                                </li>
                                                <li v-else-if="$store.getters.getConfig('has_permissions').includes('roles-update')">
                                                    <a href="javascript:void(0);" @click="handleEdit(scope.row)"><i class="icon-edit" :title="$t('Edit')"></i></a>
                                                </li>
                                                <li v-if="$store.getters.getConfig('has_permissions').includes('roles-destroy')">
                                                    <a href="javascript:void(0);" @click="handleDelete(scope.$index, scope.row)" :title="$t('Delete')"><i class=" icon-delete"></i></a>
                                                </li>
                                                <li v-if="$store.getters.getConfig('has_permissions').includes('roles-show') && scope.row.id != 1">
                                                    <a href="javascript:void(0);" @click="handlePermission(scope.row.id)" :title="$t('Edit Permission')"><i class="el-icon-tickets"></i></a>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Name')" sortable="custom" prop="name" width="200">
                                        <template slot-scope="scope">
                                            <template v-if="scope.row.edit">
                                                <el-input v-model="scope.row.name"></el-input>
                                            </template>
                                            <span v-else>{{ scope.row.name }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" prop="created_at" width="250">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.created_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination v-if="roles.meta.total" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="roles.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0':
                                            roles.data.length, '1': roles.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import CreateRole from './CreateRole'
    export default {
        components: {
            "create-role": CreateRole
        },
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc"
                },
                dialogFormVisible: false,
                parent_roles: [],
                formLabelWidth: "120px",
                roles: {
                    meta: {},
                    data: []
                },
                currentRow: {},
                dummyRow: {}
            };
        },
        mounted() {
            this.getRole();
        },
        methods: {
            getRole() {
                request({
                    url: "roles",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.roles = response.data;
                    this.roles.data = this.roles.data.map(v => {
                        this.$set(v, 'edit', false)
                        return v
                    });
                });
            },
            getParentName(parent_id) {
                var parent_data = this.parent_roles.filter(a => parent_id && a.id === parent_id)[0];
                if (parent_data) {
                    return parent_data.name;
                }
            },
            handleEdit(row) {
                this.cancelEdit(this.dummyRow)
                this.currentRow = Object.assign({}, row);
                this.dummyRow = row;
                row.edit = !row.edit;
            },
            cancelEdit(row) {
                row.edit = false;
                Object.assign(row, this.currentRow);
            },
            confirmEdit(row) {
                row.edit = false
                request({
                    url: "roles/" + row.id,
                    method: "PATCH",
                    data: row
                }).then(response => {
                    Object.assign(row, response.data.data);
                    this.currentRow = Object.assign({}, row);
                    this.$notify({
                        title: this.$t('Success'),
                        message: response.data.message,
                        type: 'success',
                        offset: 50
                    })
                }).catch(error => {
                    this.$notify({
                        title: this.$t('Error'),
                        message: error.error.message,
                        type: "error",
                        offset: 50
                    });
                });
            },
            handlePermission(id) {
                this.$router.push({
                    name: 'ShowRole',
                    params: {
                        id: id
                    }
                });
            },
            handleDelete(index, row) {
                this.$confirm(
                    this.$t('This will permanently delete the') + ' ' + this.$t('Role') + '. ' + this.$t('Do you want to continue?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('OK'),
                        cancelButtonText: this.$t('Cancel'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "roles/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {
                            this.getRole();
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.getRole(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getRole();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getRole();
            },
            indexMethod(index) {
                return (
                    index +
                    this.filterData.pageLength * this.filterData.page -
                    this.filterData.pageLength +
                    1
                );
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Role/Role.vue